// Calls the meet-analyze workspace endpoint for a room and returns the
// analysis row { room_id, summary, suggestions, model, generated_at,
// applied_items? }. Pass force=true to bust the cached row and re-extract.
//
// Routes through workspaceProject.aiMeetAnalyze (rpc) → POST /ai/meet-
// analyze on the workspace worker, which forwards the user's JWT to
// the meet-analyze Supabase edge function. The edge function caches in
// `meet_transcript_analyses` keyed by room_id; re-opening the
// transcript hits the cache, no model call. force=1 bypasses cache.
//
// All AI/data calls flow through @symbo.ls/sdk — never raw fetch to
// Supabase from the frontend. The SDK adapter handles auth, retries,
// and the migration path when AI endpoints move to first-class server
// routes.
import { getSDK } from '../../../shared/functions/sdk.js'

export const analyzeTranscript = async function (roomId, force = false) {
  const sdk = getSDK()
  // sdk.getSession() returns Promise<session> in v3.14 — without await
  // `session` is the Promise itself and access_token is undefined.
  const session = await sdk.getSession()
  if (!session?.access_token) {
    const err = new Error('session expired — please sign in again')
    err.status = 401
    throw err
  }

  try {
    return await sdk.execute('workspaceProject.aiMeetAnalyze', 'rpc', { roomId, force: !!force })
  } catch (err) {
    const message = err?.message || ''
    let status = 0
    const m = message.match(/HTTP\s+(\d+)/iu) || message.match(/^(\d+)\s/u)
    if (m) status = parseInt(m[1], 10)
    const reason =
      message ||
      (status === 422 ? 'no transcript available yet'
        : status === 403 ? 'not allowed to read this room'
          : status === 401 ? 'session expired — please sign in again'
            : `status ${status || '?'}`)
    console.error('[analyzeTranscript]', status || '?', reason)
    const out = new Error(reason)
    out.status = status
    throw out
  }
}
